import { useState } from "react";
import { Box, Button, Container, Heading, Stack, Text } from "@chakra-ui/react";
import { Config } from "../../config/Config";

export const CmsLoginPage = (): JSX.Element => {
	const [error, setError] = useState<string | null>(null);

	const handleGoogleSignIn = () => {
		if (!Config.cmsGoogleClientId) {
			setError("CMS Google Client ID is not configured. Please contact the administrator.");
			return;
		}
		setError(null);
		// Redirect to Google OAuth consent screen
		const clientId = Config.cmsGoogleClientId;
		const redirectUri = `${window.origin}/cms/callback`;
		const scope = "openid email profile";
		const state = crypto.randomUUID();
		sessionStorage.setItem("oauth_state", state);
		const nonce = crypto.randomUUID();
		sessionStorage.setItem("oauth_nonce", nonce);
		const url = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=id_token&scope=${encodeURIComponent(scope)}&nonce=${nonce}&state=${state}`;
		window.location.href = url;
	};

	return (
		<Box minH="100vh" bg="gray.50" display="flex" alignItems="center" justifyContent="center">
			<Container maxW="md">
				<Stack spacing="8" textAlign="center" bg="white" p="10" borderRadius="xl" boxShadow="lg">
					<Heading size="lg" color="gray.800">Geco CMS Admin</Heading>
					<Text color="gray.600">Sign in with your Google account to manage website content.</Text>
					<Button
						colorScheme="blue"
						size="lg"
						onClick={handleGoogleSignIn}
					>
						Sign in with Google
					</Button>
					{error && <Text color="red.500" fontSize="sm">{error}</Text>}
					<Text fontSize="xs" color="gray.400">
						Only authorized email addresses can access the CMS.
					</Text>
				</Stack>
			</Container>
		</Box>
	);
};
